import React, { forwardRef } from 'react';
import PreservoirLogomark from '@assets/brand/preservoir-logomark.svg';
import styles from './SuccessScreen.module.css';

export interface ISuccessScreenProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: string;
  message: React.ReactNode;
  primaryButton: {
    label: string;
    onClick: () => void;
  };
  secondaryButton?: {
    label: string;
    onClick: () => void;
  };
}

const SuccessScreen = forwardRef<HTMLDivElement, ISuccessScreenProps>(
  ({ title, message, primaryButton, secondaryButton, className, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={[styles.successScreen, className].filter(Boolean).join(' ')}
        {...rest}
      >
        <div className={styles.successIcon}>
          <img src={PreservoirLogomark} alt="Preservoir" />
        </div>
        <h2 className={styles.successTitle}>{title}</h2>
        <div className={styles.successMessage}>
          {typeof message === 'string' ? <p>{message}</p> : message}
        </div>
        <div className={styles.successButtons}>
          {secondaryButton && (
            <button className={styles.secondaryButton} onClick={secondaryButton.onClick}>
              {secondaryButton.label}
            </button>
          )}
          <button className={styles.primaryButton} onClick={primaryButton.onClick}>
            {primaryButton.label}
          </button>
        </div>
      </div>
    );
  },
);

SuccessScreen.displayName = 'SuccessScreen';

export default SuccessScreen;
